import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { Grid, TextField, Button, Select, MenuItem } from '@material-ui/core';
import style from './NewPatientInfo.module.css';
import { withLang } from '../../../util/lang';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { ApiServerUrl } from '../../../config.json';
import join from 'url-join';
import axios, { safeGet, safePostWithProgress } from '../../../axios-default';
import { smileDesignProductListArray } from '../../../store/SmileDesign/SmileDesignSlice';
import NewPatientProfilePic from './NewPatientProfilePic';

// material ui and css stuff

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            minHeight: '400px',
        },
    },
    mainCard: {
        backgroundColor: 'white',
        borderRight: 'solid 6px #353535',
        color: 'white',
        [theme.breakpoints.down('xs')]: {
            borderRight: 'none',
        },
    },
    mainContainer: {
        textAlign: 'left',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
        backgroundColor: 'white',
        padding: 16,
        [theme.breakpoints.down('xs')]: {
            maxHeight: 'unset',
        },
    },
    textField: {
        width: '100%',
        fontWeight: '300 !important',
    },
    textfieldContainer: {
        padding: 4,
    },
    genderSelectMale: {
        borderLeft: 'solid 1px #4a4f90',
        borderTop: 'solid 1px #4a4f90',
        borderBottom: 'solid 1px #4a4f90',
        borderRadius: 0,
        color: '#4a4f90',
        padding: '4px 24px',
        fontWeight: 300,
    },
    genderSelectFemale: {
        borderRight: 'solid 1px #4a4f90',
        borderTop: 'solid 1px #4a4f90',
        borderBottom: 'solid 1px #4a4f90',
        borderRadius: 0,
        color: '#4a4f90',
        padding: '4px 24px',
        fontWeight: 300,
    },
    genderSelectOther: {
        borderRight: 'solid 1px #4a4f90',
        borderTop: 'solid 1px #4a4f90',
        borderBottom: 'solid 1px #4a4f90',
        borderRadius: 0,
        color: '#4a4f90',
        padding: '4px 24px',
        fontWeight: 300,
    },
    genderSelectActive: {
        border: 'solid 1px #4a4f90',
        borderRadius: 0,
        backgroundColor: '#4a4f90',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        '&:hover': {
            background: '#4a4f90',
            color: 'white',
        },
    },
    dateLabel: {
        marginBlockStart: '8px',
        marginBlockEnd: '8px',
        fontSize: '14px',
    },
});

class NewPatientInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rotateDegree: 0,
            tabValue: this.props.defaultTabOpen ?? 0,
            selectedExistingPatient: this.props.current_patient_id ?? '',
        };
        this.removefile = this.removefile.bind(this);
        this.rotate = this.rotate.bind(this);
        this.doctor_patient_CanSubmitSmileDesignCaseList = this.props.doctor_patient_CanSubmitSmileDesignCaseList;
        this.tabArray = [this.get('Patient_select_tab.new_patient'), this.get('Patient_select_tab.existing_patient')];
    }

    handleDrop = (uploadedFile) => {
        this.fileupload(uploadedFile);
    };

    rotate(e, direction) {
        if (direction == 'rotateRight') {
            this.setState(
                (currentState) => ({ rotateDegree: (currentState.rotateDegree % 360) + 90 }),
                () => {
                    this.props.handleDataPhotoRotate(this.state.rotateDegree);
                }
            );
        } else {
            this.setState(
                (currentState) => ({ rotateDegree: (currentState.rotateDegree % 360) - 90 }),
                () => {
                    this.props.handleDataPhotoRotate(this.state.rotateDegree);
                }
            );
        }
    }

    checkInvalid() {
        if (this.props.firstName.length == 0) {
            this.props.ErrorData({ id: 'patient_info', msg: this.get('warning.firstName'), valid: false });
        } else if (this.props.lastName.length == 0) {
            this.props.ErrorData({ id: 'patient_info', msg: this.get('warning.lastName'), valid: false });
        } else {
            this.props.ErrorData({ id: 'patient_info', msg: '', valid: true });
        }
    }

    fileupload(file) {
        let ClassThis = this;
        ClassThis.props.handleDataPhoto(file);
    }

    removefile() {
        this.props.handleDataPhoto(null);
        this.setState({ rotateDegree: 0 });
    }
    returnTreatmentOpts() {
        const menuItems = [];

        // Check if this.props.pm is defined and has a length greater than 0
        if (this.props.pm && this.props.pm.length > 0 && this.props.caseTypeId !== 5) {
            // Iterate over each item in this.props.pm and push a MenuItem into the menuItems array
            this.props.pm.forEach((pm) => {
                // Exclude items where pm.case_type_id is equal to 5
                if (pm.case_type_id !== 5) {
                    menuItems.push(
                        <MenuItem key={pm.case_type_id} value={pm.case_type_id}>
                            {pm.product_name}
                        </MenuItem>
                    );
                }
            });
        } else {
            // Handle the case when this.props.pm is undefined or has length 0
            if (this.props.pm && this.props.pm.length > 0 && this.props.caseTypeId === 5) {
                this.props.pm.forEach((pm) => {
                    // Exclude items where pm.case_type_id is equal to 5
                    if (pm.case_type_id === 5) {
                        menuItems.push(
                            <MenuItem key={pm.case_type_id} value={pm.case_type_id}>
                                {pm.product_name}
                            </MenuItem>
                        );
                    }
                });
            }
        }

        // Return the array of MenuItem components
        return menuItems;
    }

    returnDays() {
        let ary = [];
        let days = 0;
        let bigMonth = [1, 3, 5, 7, 8, 10, 12];
        if (this.props.month !== 2 && bigMonth.includes(this.props.month)) {
            days = 31;
        }
        if (this.props.month !== 2 && !bigMonth.includes(this.props.month)) {
            days = 30;
        } else if (this.props.month === 2 && this.props.year % 4 === 0) {
            days = 29;
        } else if (this.props.month === 2 && this.props.year % 4 !== 0) {
            days = 28;
        }
        for (let i = 1; i < days + 1; i++) {
            ary.push(
                <MenuItem value={i} key={'day' + i}>
                    {i}
                </MenuItem>
            );
            if (i === days) return ary;
        }
    }
    removefile() {
        this.props.handleDataPhoto(null);
        this.setState({ rotateDegree: 0 });
    }
    returnTreatmentOpts() {
        const menuItems = [];

        // Check if this.props.pm is defined and has a length greater than 0
        if (this.props.pm && this.props.pm.length > 0 && this.props.caseTypeId !== 5) {
            // Iterate over each item in this.props.pm and push a MenuItem into the menuItems array
            this.props.pm.forEach((pm) => {
                // Exclude items where pm.case_type_id is equal to 5
                if (pm.case_type_id !== 5) {
                    menuItems.push(
                        <MenuItem key={pm.case_type_id} value={pm.case_type_id}>
                            {pm.product_name}
                        </MenuItem>
                    );
                }
            });
        } else {
            // Handle the case when this.props.pm is undefined or has length 0
            if (this.props.pm && this.props.pm.length > 0 && this.props.caseTypeId === 5) {
                this.props.pm.forEach((pm) => {
                    // Exclude items where pm.case_type_id is equal to 5
                    if (pm.case_type_id === 5) {
                        menuItems.push(
                            <MenuItem key={pm.case_type_id} value={pm.case_type_id}>
                                {pm.product_name}
                            </MenuItem>
                        );
                    }
                });
            }
        }

        // Return the array of MenuItem components
        return menuItems;
    }

    returnDays() {
        let ary = [];
        let days = 0;
        let bigMonth = [1, 3, 5, 7, 8, 10, 12];
        if (this.props.month !== 2 && bigMonth.includes(this.props.month)) {
            days = 31;
        }
        if (this.props.month !== 2 && !bigMonth.includes(this.props.month)) {
            days = 30;
        } else if (this.props.month === 2 && this.props.year % 4 === 0) {
            days = 29;
        } else if (this.props.month === 2 && this.props.year % 4 !== 0) {
            days = 28;
        }
        for (let i = 1; i < days + 1; i++) {
            ary.push(
                <MenuItem value={i} key={'day' + i}>
                    {i}
                </MenuItem>
            );
            if (i === days) return ary;
        }
    }

    returnMonths() {
        let ary = [];
        for (let i = 1; i < 13; i++) {
            ary.push(
                <MenuItem value={i} key={'month' + i}>
                    {i}
                </MenuItem>
            );
            if (i === 12) return ary;
        }
    }

    returnYears() {
        let ary = [];
        let thisYear = new Date().getYear() + 1800;
        for (let i = thisYear; i < thisYear + 101; i++) {
            ary.push(
                <MenuItem value={i} key={'year' + i}>
                    {i}
                </MenuItem>
            );
            if (i === thisYear + 100) return ary;
        }
    }

    onFileChange = ({
        target: {
            files: [file],
        },
    }) => {
        let compo = this;
        compo.props.handleDataPhoto(file);
    };

    handleChange = async (value) => {
        this.setState({ tabValue: value });
        await this.handleChangeToDiffTab(value);
    };

    handleChangeToDiffTab = async (value) => {
        if (this.state.tabValue === value) return;
        switch (this.tabArray[value]) {
            case this.tabArray[0]:
                await this.ClearNewPatientInfo();
                break;
            case this.tabArray[1]:
                await this.ClearExistPatientInfo();
                break;
        }
    };
  // 清空 Existing Patient 选择和已填充的患者信息。
    ClearExistPatientInfo = async () => {
        this.props.UpdateNewCaseForExistPatientFunc(null);
        this.setState({ selectedExistingPatient: '' });
        await this.props.resetIntialGender();
        await this.props.resetIntialLastName();
        await this.props.resetIntialFirstName();
        await this.props.resetIntialDay();
        await this.props.resetIntialMonth();
        await this.props.resetIntialYear();
        await this.props.resetIntialReferenceCode();
        await this.props.resetIntialRemark();
        await this.props.resetIntialInternalRemark();
        await this.props.resetIntialDrRemark();
        await this.props.resetIntialPhoto();
    };

    ClearNewPatientInfo = async () => {
        this.props.UpdateNewCaseForExistPatientFunc(null);
        this.setState({ selectedExistingPatient: '' });
        await this.props.resetIntialGender();
        await this.props.resetIntialLastName();
        await this.props.resetIntialFirstName();
        await this.props.resetIntialDay();
        await this.props.resetIntialMonth();
        await this.props.resetIntialYear();
        await this.props.resetIntialReferenceCode();
        await this.props.resetIntialRemark();
        await this.props.resetIntialInternalRemark();
        await this.props.resetIntialDrRemark();
        await this.props.resetIntialPhoto();
    };

    SelectExistPatientByList = async (patientId, list) => {
        const selectedPatient = list.find((patient) => patient.patient_id === patientId);
        this.setState({ selectedExistingPatient: patientId });
        this.props.UpdateNewCaseForExistPatientFunc(patientId);
        await this.AutoFillPatientInfo(selectedPatient);
    };

    AutoFillPatientInfo = async (selectedPatient) => {
        const splitDate = selectedPatient.date_of_birth.split('-');
        await this.props.handleDataFirstName(selectedPatient.first_name);
        await this.props.handleDataLastName(selectedPatient.last_name);
        await this.props.handleDataGender(selectedPatient.gender);
        await this.props.handleDataDay(splitDate[0]);
        await this.props.handleDataMonth(splitDate[1]);
        await this.props.handleDataYear(splitDate[2]);
        await this.props.handleDataRemark(selectedPatient.remarks);
        await this.props.handleDataDrRemark(selectedPatient.dr_remark);
        const profilePic = selectedPatient.profile_pic ? join(ApiServerUrl, selectedPatient.profile_pic) : '';
        if (profilePic != '') {
            const profilePicresponse = await axios.get(profilePic, { responseType: 'blob' });

            const mimeType = profilePicresponse.headers['content-type'];
            const contentDisposition = profilePicresponse.headers['content-disposition'];
            let fileName = 'profilePic'; // Default file name

            if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            const blob = profilePicresponse.data;
            const file = new File([blob], fileName, { type: mimeType });
            await this.props.handleDataPhoto(file);
        } else {
            await this.props.handleDataPhoto(null);
        }
    };

    renderPatientInfoModel(
        isExistPatientMode = false,
        classes,
        profilePic,
        role,
        editNewCase,
        case_id,
        isSamePatientCreateNewCaseAction = false
    ) {
        // Existing Patient 选择患者后锁定已填充信息，清空后允许填写。
        const isExistingPatientInfoDisabled = isExistPatientMode && this.state.selectedExistingPatient !== '';

        return (
            <>
                {!isSamePatientCreateNewCaseAction && isExistPatientMode && (
                    <Grid item xs={12} md={12}>
                        <p className={classes.dateLabel}>{this.get('Patient_select_tab.existing_patient')}:</p>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Select
                                value={this.state.selectedExistingPatient}
                                labelId="doctor-patient-list"
                                id="doctor-patient-list-id"
                                label="Create new case from existing patient"
                                    // Exist Patient
                                onChange={async (event) => {
                                    await this.SelectExistPatientByList(
                                        event.target.value,
                                        this.props.doctor_patient_list
                                    );
                                }}
                            >
                                {this.props.doctor_patient_list != null &&
                                    this.props.doctor_patient_list.map((it) => (
                                        <MenuItem value={it.patient_id} key={`patient-${it.patient_id}`}>
                                            {it.first_name} {it.last_name} -{' '}
                                            {this.get('Patient_select_tab.existing_patient_list_Id')}: {it.patient_id}
                                        </MenuItem>
                                    ))}
                            </Select>
                           {
                                this.state.selectedExistingPatient && (
                                    <div
                                        style={{ marginLeft: 8 ,cursor: 'pointer'}}
                                        onClick={async () => {
                                            await this.ClearExistPatientInfo();
                                        }}
                                    >
                                        <DeleteOutlinedIcon  style={{ color: 'red' }}/>
                                    </div>
                                )
                            }
                        </div>
                    </Grid>
                )}

                {/* {!isSamePatientCreateNewCaseAction &&
                    isExistPatientMode &&
                    smileDesignProductListArray.includes(this.props.newCaseType) && (
                        <Grid item xs={12} md={12}>
                            <p className={classes.dateLabel}>
                                {this.get('@NewPatient.Patient_select_tab.createSmileDesignCase')}:
                            </p>
                            <Select
                                value={this.state.selectedExistingPatient}
                                labelId="doctor-smileDesign-patient-list"
                                id="doctor-smileDesign-patient-list-id"
                                label="Create Smile Design for Existing Patient"
                                onChange={async (event) => {
                                    await this.SelectExistPatientByList(
                                        event.target.value,
                                        this.props.doctor_patient_CanSubmitSmileDesignCaseList
                                    );
                                }}
                            >
                                {this.props.doctor_patient_CanSubmitSmileDesignCaseList != null &&
                                    this.props.doctor_patient_CanSubmitSmileDesignCaseList.map((it) => (
                                        <MenuItem value={it.patient_id} key={`smileDesign-patient-${it.patient_id}`}>
                                            {it.first_name} {it.last_name} -{' '}
                                            {this.get('Patient_select_tab.existing_patient_list_Id')}: {it.patient_id} -{' '}
                                            {it.case_type}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid>
                    )
                }
                {!isSamePatientCreateNewCaseAction &&
                    isExistPatientMode &&
                    !smileDesignProductListArray.includes(this.props.newCaseType) &&
                    this.props.smileDesign.isReleaseSmileDesignByDistriAndAllowUserTest && (
                        <Grid item xs={12} md={12}>
                            <p className={classes.dateLabel}>
                                {this.get('@NewPatient.Patient_select_tab.createAlignerCase')}:
                            </p>
                            <Select
                                value={this.state.selectedExistingPatient}
                                labelId="doctor-aligner-case-patient-list"
                                id="doctor-aligner-case-patient-list-id"
                                label="Create Aligner Case for Existing Patient"
                                onChange={async (event) => {
                                    await this.SelectExistPatientByList(
                                        event.target.value,
                                        this.props.doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList
                                    );
                                }}
                            >
                                {this.props.doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList != null &&
                                    this.props.doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList.map((it) => (
                                        <MenuItem value={it.patient_id} key={`aligner-case-patient-${it.patient_id}`}>
                                            {it.first_name} {it.last_name} -{' '}
                                            {this.get('Patient_select_tab.existing_patient_list_Id')}: {it.patient_id} -{' '}
                                            {it.case_type}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid>
                    )} */}

                {/*  is Exist Patient */}

                <Grid item xs={12} md={6} style={{ textAlign: 'center' }}>
                    <Grid container>
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12} style={{ padding: 12 }}>
                            {
                                <>
                                    <NewPatientProfilePic
                                        handleDrop={this.handleDrop}
                                        onFileChange={this.onFileChange}
                                        rotate={this.rotate}
                                        profilePicData={profilePic}
                                        removeFile={this.removefile}
                                    />
                                </>
                            }
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                    <div>
                        <Grid container>
                            <Grid item xs={12} sm={6} className={classes.textfieldContainer}>
                                <TextField
                                    id="firstName"
                                    label={'*' + this.get(':fields.firstName')}
                                    className={classes.textField}
                                    style={{ marginTop: '5px' }}
                                    value={this.props.firstName}
                                    disabled={isExistingPatientInfoDisabled}
                                    onChange={async (event) => {
                                        await this.props.handleDataFirstName(event.target.value);
                                        this.checkInvalid();
                                    }}
                                    margin="normal"
                                />
                                <p className={style.error}>{this.props.error && this.props.error['firstName']}</p>
                            </Grid>

                            <Grid item xs={12} sm={6} className={classes.textfieldContainer}>
                                <TextField
                                    id="lastName"
                                    label={'*' + this.get(':fields.lastName')}
                                    className={classes.textField}
                                    style={{ marginTop: '5px' }}
                                    disabled={isExistingPatientInfoDisabled}
                                    value={this.props.lastName}
                                    onChange={async (event) => {
                                        await this.props.handleDataLastName(event.target.value);
                                        this.checkInvalid();
                                    }}
                                    margin="normal"
                                />
                                <p className={style.error}>{this.props.error && this.props.error['lastName']}</p>
                            </Grid>
                            <Grid item xs={12} className={classes.textfieldContainer}>
                                <b>{this.get(':fields.gdprNotice')}</b>
                            </Grid>
                            <Grid item xs={12} className={classes.textfieldContainer}>
                                <p>{this.get(':fields.gender')}</p>
                                <Button
                                    disabled={isExistingPatientInfoDisabled}
                                    className={
                                        this.props.gender === 'M'
                                            ? classes.genderSelectActive
                                            : classes.genderSelectMale
                                    }
                                    onClick={() => this.props.handleDataGender('M')}
                                >
                                    {this.get(':fields.male')}
                                </Button>
                                <Button
                                    disabled={isExistingPatientInfoDisabled}
                                    className={
                                        this.props.gender === 'F'
                                            ? classes.genderSelectActive
                                            : classes.genderSelectFemale
                                    }
                                    onClick={() => this.props.handleDataGender('F')}
                                >
                                    {this.get(':fields.female')}
                                </Button>
                                <Button
                                    disabled={isExistingPatientInfoDisabled}
                                    className={
                                        this.props.gender === 'O'
                                            ? classes.genderSelectActive
                                            : classes.genderSelectOther
                                    }
                                    onClick={() => this.props.handleDataGender('O')}
                                >
                                    {this.get(':fields.other')}
                                </Button>
                            </Grid>
                            <Grid item xs={12} className={classes.textfieldContainer}>
                                {['DR'].includes(role) && editNewCase && case_id && (
                                    <>
                                        <p className={classes.dateLabel}>
                                            {this.get('@Patients.case_list.columns.treatmentOption')}
                                        </p>
                                        <Select
                                            value={this.props.caseTypeId}
                                            onChange={(event) =>
                                                this.props.handleChangeTreatmentOpts(event.target.value)
                                            }
                                        >
                                            {this.returnTreatmentOpts()}
                                        </Select>
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} className={classes.textfieldContainer}>
                                <p>{this.get(':fields.dateOfBirth')}</p>
                                <Grid container>
                                    <Grid item xs={4} style={{ padding: 4 }}>
                                        <p className={classes.dateLabel}>{this.get(':fields.day')}</p>
                                        <Select
                                            value={this.props.day}
                                            disabled={isExistingPatientInfoDisabled}
                                            onChange={(event) => this.props.handleDataDay(event.target.value)}
                                            inputProps={{
                                                name: 'day',
                                                id: 'day',
                                            }}
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            {this.returnDays()}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={4} style={{ padding: 4 }}>
                                        <p className={classes.dateLabel}>{this.get(':fields.month')}</p>
                                        <Select
                                            value={this.props.month}
                                            disabled={isExistingPatientInfoDisabled}
                                            onChange={(event) => this.props.handleDataMonth(event.target.value)}
                                            inputProps={{
                                                name: 'month',
                                                id: 'month',
                                            }}
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            {this.returnMonths()}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={4} style={{ padding: 4 }}>
                                        <p className={classes.dateLabel}>{this.get(':fields.year')}</p>
                                        <Select
                                            value={this.props.year}
                                            disabled={isExistingPatientInfoDisabled}
                                            onChange={(event) => this.props.handleDataYear(event.target.value)}
                                            inputProps={{
                                                name: 'year',
                                                id: 'year',
                                            }}
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            {this.returnYears()}
                                        </Select>
                                    </Grid>

                                    {['ADMIN', 'SADMIN', 'DISTR'].includes(role) && !editNewCase && (
                                        <Grid item xs={12} className={classes.textfieldContainer}>
                                            <p style={{ marginBlockEnd: 0 }}>{this.get(':fields.refCode')}</p>
                                            <TextField
                                                id="refCode"
                                                className={classes.textField}
                                                value={this.props.refCode == null ? '' : this.props.refCode}
                                                onChange={(event) => {
                                                    this.props.handleDataRefCode(event.target.value);
                                                }}
                                                margin="normal"
                                            />
                                            <p className={style.error}>
                                                {this.props.error && this.props.error['refCode']}
                                            </p>
                                        </Grid>
                                    )}
                                    {/* internal remark box */}
                                    {['DISTR'].includes(role) && !editNewCase && (
                                        <Grid item xs={12} className={classes.textfieldContainer}>
                                            <p style={{ marginBlockEnd: 0 }}>
                                                {this.get('@PatientInfo.case_info.distributorInternalRemarks')}
                                            </p>
                                            <TextField
                                                id="refCode"
                                                className={classes.textField}
                                                value={
                                                    this.props.internalRemarks == null ? '' : this.props.internalRemarks
                                                }
                                                onChange={(event) => {
                                                    this.props.handleDataInternalRemark(event.target.value);
                                                }}
                                                margin="normal"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                placeholder={this.get(
                                                    '@PatientInfo.case_info.distributorInternalRemarks'
                                                )}
                                            />
                                            <p className={style.error}>
                                                {this.props.error && this.props.error['internalRemarks']}
                                            </p>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} className={classes.textfieldContainer}>
                                        <p style={{ marginBlockEnd: 0 }}>{this.get(':fields.remarks')}</p>
                                        <TextField
                                            id="remarks"
                                            // label="Remarks"
                                            className={classes.textField}
                                            value={this.props.remarks == null ? '' : this.props.remarks}
                                            onChange={(event) => this.props.handleDataRemark(event.target.value)}
                                            disabled={isExistingPatientInfoDisabled}
                                            margin="normal"
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            placeholder={this.get(':fields.remarks')}
                                        />
                                    </Grid>
                                    {['DR'].includes(role) && (
                                        <Grid item xs={12} className={classes.textfieldContainer}>
                                            <p style={{ marginBlockEnd: 0 }}>{this.get(':fields.drRemarks')}</p>
                                            <TextField
                                                id="dr_remarks"
                                                className={classes.textField}
                                                value={this.props.dr_remark == null ? '' : this.props.dr_remark}
                                                onChange={(event) => this.props.handleDataDrRemark(event.target.value)}
                                                disabled={isExistingPatientInfoDisabled}
                                                margin="normal"
                                                variant="outlined"
                                                multiline
                                                rows={4}
                                                placeholder={this.get(':fields.drRemarks')}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </>
        );
    }

    renderDrRemarksModel(
        isExistPatientMode = false,
        classes,
        profilePic,
        role,
        editNewCase,
        case_id,
        isSamePatientCreateNewCaseAction = false
    ){
        return(
            <Grid item xs={12} className={classes.textfieldContainer}>
                <TextField
                    id="dr_remarks"
                    className={classes.textField}
                    value={this.props.dr_remark == null ? '' : this.props.dr_remark}
                    onChange={(event) => this.props.handleDataDrRemark(event.target.value)}
                    disabled={
                        isExistPatientMode ??
                        this.props.disabledNewPatientInfoInputObj.dr_remark ??
                        false
                    }
                    margin="normal"
                    variant="outlined"
                    multiline
                    rows={4}
                    placeholder={this.get(':fields.drRemarks')}
                />
            </Grid>
        )
    }

    render() {
        const { classes, editNewCase, case_id } = this.props;
        const profilePic = {
            data: this.props.patientPhoto?.dataURL ?? this.props.patientPhoto?.data,
            rotate: this.props.patientPhoto?.rotate ?? 0,
        };
        const { role } = this.props;
        return (
            <div style={{ display: 'contents' }}>
                {!this.props.isStartedCaseEditPatientInfo && !this.props.isStartedCaseDrRemarks &&(
                    <>
                        {/* <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
                            <Grid>
                                <Tabs
                                    value={this.state.tabValue}
                                    onChange={async (e, v) => {
                                        await this.handleChange(v);
                                    }}
                                    variant="fullWidth"
                                >
                                    {this.tabArray
                                        .filter((it) =>
                                            this.props.isSamePatientCreateNewCaseAction ? it == this.tabArray[1] : true
                                        )
                                        .map((it, index) => (
                                            <Tab
                                                key={`tab-${index}`}
                                                label={it}
                                                disabled={this.props.isSamePatientCreateNewCaseAction}
                                            />
                                        ))}
                                </Tabs>
                            </Grid>
                        </Grid> */}
                        {/* <>
                            {!this.props.isStartedCaseEditPatientInfo &&
                                this.state.tabValue === 0 &&
                                this.renderPatientInfoModel(
                                    false,
                                    classes,
                                    profilePic,
                                    role,
                                    editNewCase,
                                    case_id,
                                    false
                                )}
                        </> */}
                        <>
                        {/* && this.state.tabValue === 1 */}
                            {!this.props.isStartedCaseEditPatientInfo  &&
                                this.renderPatientInfoModel(
                                    true,
                                    classes,
                                    profilePic,
                                    role,
                                    editNewCase,
                                    case_id,
                                    this.props.isSamePatientCreateNewCaseAction
                                )}
                        </>
                    </>
                )}
                {/* for can update Patient info Role in exist case */}
                {this.props.isStartedCaseEditPatientInfo && !this.props.isStartedCaseDrRemarks &&
                    this.renderPatientInfoModel(false, classes, profilePic, role, editNewCase, case_id, false)}
                {/* for can update Dr Remarks Role in exist case */}
                {!this.props.isStartedCaseEditPatientInfo && this.props.isStartedCaseDrRemarks &&
                    this.renderDrRemarksModel(false, classes, profilePic, role, editNewCase, case_id, false)}
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        gender: store.newPatientReducer.gender,
        lastName: store.newPatientReducer.lastName,
        firstName: store.newPatientReducer.firstName,
        day: store.newPatientReducer.day,
        month: store.newPatientReducer.month,
        year: store.newPatientReducer.year,
        refCode: store.newPatientReducer.refCode,
        remarks: store.newPatientReducer.remarks,
        internalRemarks: store.newPatientReducer.internalRemarks,
        dr_remark: store.newPatientReducer.dr_remark,
        patientPhoto: store.newPatientReducer.patientPhoto,
        caseTypeId: store.newPatientReducer.case_type_id,
        smileDesign: store.smileDesign,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleChangeTreatmentOpts: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_INFO_CHANGE_TP_OPTS, value: value }),
        handleDataGender: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_GENDER, value: value }),
        handleDataLastName: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_LASTNAME, value: value }),
        handleDataFirstName: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_FIRSTNAME, value: value }),
        handleDataDay: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_DAY, value: value }),
        handleDataMonth: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_MONTH, value: value }),
        handleDataYear: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_YEAR, value: value }),
        handleDataRefCode: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_REFERENCE_CODE, value: value }),
        handleDataRemark: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_REMARK, value: value }),
        handleDataInternalRemark: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INTERNAL_REMARK, value: value }),
        handleDataDrRemark: (value) => dispatch({ type: actionTypes.NEW_PATIENT_DR_REMARK, value: value }),
        handleDataPhoto: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_PHOTO, value: value }),
        handleDataPhotoRotate: (value) => dispatch({ type: actionTypes.NEW_PATIENT_INFO_PHOTO_ROTATE, value: value }),
        resetIntialGender: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_GENDER }),
        resetIntialLastName: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_LASTNAME }),
        resetIntialFirstName: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_FIRSTNAME }),
        resetIntialDay: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_DAY }),
        resetIntialMonth: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_MONTH }),
        resetIntialYear: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_YEAR }),
        resetIntialReferenceCode: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_REFERENCE_CODE }),
        resetIntialRemark: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_REMARK }),
        resetIntialInternalRemark: () => dispatch({ type: actionTypes.NEW_PATIENT_RESET_INTERNAL_REMARK }),
        resetIntialDrRemark: () => dispatch({ type: actionTypes.NEW_PATIENT_RESET_DR_REMARK }),
        resetIntialPhoto: () => dispatch({ type: actionTypes.NEW_PATIENT_INFO_RESET_PHOTO }),
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(NewPatientInfo, 'NewPatient'))));
